import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Greeting from './components/Greeting';
import About from './components/About';
import Guidelines from './components/Guidelines';
import Review from './components/Review';
import Gallery from './components/Gallery';
import Schedule from './components/Schedule';
import Venue from './components/Venue';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Header />
      <main>
        <Hero />
        <Greeting />
        <About />
        <Guidelines />
        <Review />
        <Gallery />
        <Schedule />
        <Venue />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
